module.exports = __webpack_public_path__ + "img/9791185871066.7589f575.jpg";